import React, { useRef } from "react"
import { useReviews } from "../../../hooks/useReviews"
import Container from "../../atoms/Container"
import "./Reviews.css"
import SliderWrapper from "../../atoms/SliderWrapper"

export default function Reviews({ block }) {
  const data = useReviews()
  const ref = useRef()
  const arrow = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M6.38086 12.0467L2.33419 7.99999L6.38086 3.95333"
        stroke="#0E0E0E"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.666 8L2.44602 8"
        stroke="#0E0E0E"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )

  var settings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    dots: false,
    speed: 300,
    autoplaySpeed: 5000,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 425,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  }

  return (
    <Container>
      <div className="vt-review-container-120"></div>
      <div className="vt-review-container">
        <h2>{block.titel}</h2>
        <div className="vt-review-container-slider">
          <div className="vt-review__buttons hide-mobile">
            <div
              className="vt-review__button vt-review__button--prev"
              onClick={() => ref?.current?.slickPrev()}
            >
              {arrow}
            </div>
            <div
              className="vt-review__button vt-review__button--next"
              onClick={() => ref?.current?.slickNext()}
            >
              {arrow}
            </div>
          </div>
          <div className="slider-class">
            <SliderWrapper sliderRef={ref} settings={settings}>
              {data.allWpReview.edges.map(reviews => {
                const stars = []
                for (let i = 0; i < reviews.node.reviews.cijfer; i++) {
                  stars.push(
                    <span key={i}>
                      {" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="23"
                        height="23"
                        viewBox="0 0 23 23"
                        fill="none"
                        className="lg:w-[23px] lg:h-[23px] w-[16px] h-[16px]"
                      >
                        <path
                          d="M7.04422 20.7649C6.78302 20.9023 6.48859 20.9637 6.19426 20.9425C5.89992 20.9212 5.61741 20.8179 5.3787 20.6444C5.13998 20.4709 4.95458 20.2341 4.84347 19.9607C4.73236 19.6873 4.69997 19.3883 4.74997 19.0974L5.60097 14.1352L1.9986 10.6234C1.78742 10.4174 1.63807 10.1564 1.56746 9.86995C1.49684 9.58352 1.50776 9.28304 1.59898 9.00248C1.69021 8.72193 1.8581 8.47249 2.08368 8.28236C2.30926 8.09223 2.58352 7.96901 2.87547 7.92661L7.85641 7.20211L10.0845 2.68836C10.2152 2.42409 10.4172 2.20162 10.6677 2.04607C10.9181 1.89053 11.2071 1.80811 11.5019 1.80811C11.7967 1.80811 12.0857 1.89053 12.3361 2.04607C12.5866 2.20162 12.7886 2.42409 12.9193 2.68836L15.1474 7.20211L20.1298 7.92661C20.4217 7.96901 20.696 8.09223 20.9216 8.28236C21.1472 8.47249 21.315 8.72193 21.4063 9.00248C21.4975 9.28304 21.5084 9.58352 21.4378 9.86995C21.3672 10.1564 21.2178 10.4174 21.0067 10.6234L17.4014 14.1366L18.2524 19.0989C18.3024 19.3897 18.27 19.6887 18.1589 19.9621C18.0478 20.2355 17.8624 20.4724 17.6237 20.6459C17.385 20.8194 17.1025 20.9226 16.8081 20.9439C16.5138 20.9652 16.2194 20.9037 15.9582 20.7664L11.5005 18.4204L7.04422 20.7635V20.7649Z"
                          fill="#FF0000"
                        />
                      </svg>
                    </span>
                  )
                }

                return (
                  <div className="vt-review-container-content">
                    <div>
                      <h3>{reviews.node.title}</h3>
                      <h5>{reviews.node.reviews.subtitel}</h5>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: reviews.node.content,
                        }}
                      ></div>
                      <div className="flex flex-row">
                        {stars.map(s => {
                          return s
                        })}
                      </div>
                    </div>
                  </div>
                )
              })}
            </SliderWrapper>
          </div>
        </div>
        <div className="vt-review__buttons hide-desktop">
          <div
            className="vt-review__button vt-review__button--prev"
            onClick={() => ref?.current?.slickPrev()}
          >
            {arrow}
          </div>
          <div
            className="vt-review__button vt-review__button--next"
            onClick={() => ref?.current?.slickNext()}
          >
            {arrow}
          </div>
        </div>
      </div>
    </Container>
  )
}
